// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__2STTa"};